/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimeUnit } from './TimeUnit';
import {
    TimeUnitFromJSON,
    TimeUnitFromJSONTyped,
    TimeUnitToJSON,
} from './TimeUnit';

/**
 * 
 * @export
 * @interface SubscriptionDetails
 */
export interface SubscriptionDetails {
    /**
     * 
     * @type {TimeUnit}
     * @memberof SubscriptionDetails
     */
    validityUnit?: TimeUnit;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionDetails
     */
    validityAmount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SubscriptionDetails
     */
    autoRenewing?: boolean;
    /**
     * an external handle for use with a payment provider
     * @type {string}
     * @memberof SubscriptionDetails
     */
    paymentProviderHandle?: string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionDetails
     */
    paymentProviderProductId?: string;
}

/**
 * Check if a given object implements the SubscriptionDetails interface.
 */
export function instanceOfSubscriptionDetails(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubscriptionDetailsFromJSON(json: any): SubscriptionDetails {
    return SubscriptionDetailsFromJSONTyped(json, false);
}

export function SubscriptionDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionDetails {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validityUnit': !exists(json, 'validityUnit') ? undefined : TimeUnitFromJSON(json['validityUnit']),
        'validityAmount': !exists(json, 'validityAmount') ? undefined : json['validityAmount'],
        'autoRenewing': !exists(json, 'autoRenewing') ? undefined : json['autoRenewing'],
        'paymentProviderHandle': !exists(json, 'paymentProviderHandle') ? undefined : json['paymentProviderHandle'],
        'paymentProviderProductId': !exists(json, 'paymentProviderProductId') ? undefined : json['paymentProviderProductId'],
    };
}

export function SubscriptionDetailsToJSON(value?: SubscriptionDetails | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validityUnit': TimeUnitToJSON(value.validityUnit),
        'validityAmount': value.validityAmount,
        'autoRenewing': value.autoRenewing,
        'paymentProviderHandle': value.paymentProviderHandle,
        'paymentProviderProductId': value.paymentProviderProductId,
    };
}

